/**
 * Events
 */

// Fired when someone clicks on a state
export const EV_BREAKPOINT_CHANGE = 'breakpoint.change';
